module.exports = __webpack_public_path__ + "media/contract/dotted-line-2-c9c7fe45.png";